import React from "react";
import { Link } from "gatsby";
import { MDXProvider } from "@mdx-js/react";
import CookieConsent, { Cookies } from "react-cookie-consent";

import BlockHeader from "components/BlockHeader";

// SEMANTIC UI
import "semantic-ui-css/semantic.min.css";

// PRISM THEME /////////////////////////
// import "prismjs/themes/prism-okaidia.css";
// import "prismjs/plugins/line-numbers/prism-line-numbers.css"
import 'gatsby-prismjs-dracula';
import "gatsby-line-numbers-dracula";
import "gatsby-line-highlights-dracula";
import 'gatsby-syntax-highlights-dracula';
import "gatsby-code-titles-dracula";
import "gatsby-code-buttons-dracula";
///////////////////////////////////////

// GLOBAL STYLES
import "./src/css/global.css";

const shortcodes = { Link, BlockHeader }; // Provide common components here

// enable or disable analytics
if (typeof window !== undefined) {
  const hasCookieConsent = Cookies.get('CookieConsent') === 'true'

  window['ga-disable-G-403D1PY3Z5'] = !hasCookieConsent;
}

export const wrapRootElement = ({ element }) => {
  return <MDXProvider components={shortcodes}>
    <CookieConsent enableDeclineButton
      onAccept={() => {
        window['ga-disable-G-403D1PY3Z5'] = false;
      }}
      onDecline={() => {
        window['ga-disable-G-403D1PY3Z5'] = true;
      }}
    >
      Allow cookies?
    </CookieConsent>
    {element}
    </MDXProvider>;
};
